<template>
  <section class="page-title-wrap d-flex position-relative text-center over-bg" :class="{ active: active }">

    <svg
      xmlns:xlink="http://www.w3.org/1999/xlink"
      class="overflow-hidden"
      xmlns="http://www.w3.org/2000/svg"
      :viewBox="'0 0 ' + winWFix + ' ' + wrapH"
      :style="wrapStyles"
    >
      <defs>
        <linearGradient id="page5_3-b" x1="115.115%" x2="22.829%" y1="107.974%" y2="17.737%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>
        <rect id="page5_3-a" :width="winW + 2" x="-1" :height="wrapH"/>
        <linearGradient id="page5_3-c" x1="32.785%" x2="15.287%" y1="0%" y2="145.48%"
                        gradientTransform="rotate(135 0.5 0.5)">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>
        <linearGradient id="page5_3-e" x1="108.609%" x2="50%" y1="-270.211%" y2="100%"
                        gradientTransform="rotate(135 0.5 0.5)">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>
        <linearGradient id="page5_3-f" x1="39.436%" x2="60.058%" y1="-24.646%" y2="151.24%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>
      </defs>

      <use fill="url(#page5_3-b)" xlink:href="#page5_3-a"/>
      <circle
        style="opacity: 0"
        ref="bottomCirc"
        :cx="((winW / 2) - 187.5) + 187.42"
        :cy="((wrapH / 2) - 333.5) + 665.42"
        r="271.119"
        fill="url(#page5_3-c)"
      />
      <circle
        style="opacity: 0"
        ref="topCirc"
        :cx="((winW / 2) - 187.5) + 187.42"
        :cy="((wrapH / 2) - 333.5) - 67.58"
        r="271.119"
        fill="url(#page5_3-e)"
      />
      <circle
        ref="midCirc"
        :cx="((winW / 2) - 187.5) + 187.5"
        :cy="((wrapH / 2) - 333.5) + 298.5"
        r="294.5"
        fill="url(#page5_3-f)"
        fill-opacity=".85"
        :style="[ isSmall ? { opacity: 0 } : {} ]"
      />
    </svg>

    <div class="position-absolute d-flex flex-column align-items-stretch w-75 title-text"
         :style="txtStyles">
      <header class="d-flex flex-column justify-content-end align-items-center pb-5 header-wrap">

        <h1
          class="mb-0 heading"
          v-html="head"
          ref="head"
          :style="{ letterSpacing: headSpace + 'em', paddingLeft: headSpace + 'em' }"
        ></h1>
        <span class="subhead" v-html="subhead" ref="sub"></span>

      </header>

      <div class="footer-wrap d-flex flex-column justify-content-center align-items-center">

        <h2
          class="mb-4 keyword"
          v-html="kw"
          ref="kw"
          :style="{ letterSpacing: kwSpace + 'em', paddingLeft: kwSpace + 'em' }"
        ></h2>

        <div class="numeral-wrap position-relative">
          <ring-vect ref="ring"/>

          <div class="dashes d-flex justify-content-center overflow-hidden position-absolute">
            <div class="inner position-absolute h-100" :style="{ borderLeft: '1px dashed ' + mainColor }"></div>
          </div>

          <span
            class="adobe-clean-serif-med numeral position-absolute absolute-center"
            ref="num"
            v-html="numeral"
          ></span>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import { shuffleArr } from '@/lib/funcs'
  import { TimelineMax } from 'gsap'
  import TitleMixin from '@/components/report/mixins/TitleMixin'

  export default {
    name: 'Title5',
    mixins: [ TitleMixin ],
    data () { return { tl: new TimelineMax() } },
    methods: {
      setTweens () {
        this.tl.set( [ this.headSpans, this.kwSpans, this.$refs.sub, this.$refs.ring.$el, this.$refs.num, this.$refs.topCirc, this.$refs.bottomCirc ], { opacity: 0 } )
          .set( [ this.$refs.topCirc, this.$refs.bottomCirc ], { scale: 0, transformOrigin: '50% 50%' } )
          .set( this.$refs.ring.$el, { scale: 0 } )
          .set( this.$refs.sub, { yPercent: 100 } )
        if ( this.isSmall ) this.tl.set( this.$refs.midCirc, { opacity: 0 } )
      },
      tweenIn () {
        let headSpans = shuffleArr( [ ...this.headSpans ] )
        let kwSpans = shuffleArr( [ ...this.kwSpans ] )

        if ( this.isSmall ) this.tl.to( this.$refs.midCirc, this.time / 2, { opacity: 1 }, 'in' )
        this.tl.staggerTo( [ this.$refs.topCirc, this.$refs.bottomCirc ], this.time, {
          scale: 1,
          opacity: 1
        }, this.stagger * 2, 'in' )
          .to( this, this.time, { headSpace: 0.1 }, 'in' )
          .staggerTo( headSpans, this.time, { opacity: 1 }, this.stagger, 'in' )
          .to( this.$refs.sub, this.time, { opacity: 1, yPercent: 0 }, 'in' )
          .to( this, this.time, { kwSpace: 0.2666 }, 'in+=' + (this.stagger * 2) )
          .staggerTo( kwSpans, this.time, { opacity: 1 }, this.stagger, 'in+=' + (this.stagger * 2) )
          .to( this.$refs.ring.$el, this.time, { opacity: 1, scale: 1 }, 'in+=' + (this.stagger * 2) )
          .to( this.$refs.num, this.time / 2, { opacity: 1 }, 'in+=' + (this.stagger * 2 + (this.time / 2)) )
          .call( () => this.$emit( 'tween-done' ) )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/titleVects/Title5.vue